import { IconSvg, IconSvgProps } from "./icon"

export default function LocationPin(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M18.75 9c0 3.735-6.75 12.75-6.75 12.75S5.25 12.735 5.25 9a6.75 6.75 0 0 1 13.5 0Z" />
      <path d="M12 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" />
    </IconSvg>
  )
}
